import styled from 'styled-components';

export const ListaComponent = styled.div.attrs({
    className: ``
})`

    /* display: flex;
    align-items: baseline;


    .linha {
        width: 20px;
        border
    }

    .parametros {
        flex-grow: 1;
    } */

    /* position: relative; */
    

    ${props => !props.raiz && `

        padding: 5px;
        background: #e8e8e88a;

    
        .parametros {
            padding-left: 10px;
            position: relative;

            &:after {
                content: "";
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                width: 7px;
                border-left: 2px solid grey;
                border-bottom: 2px solid grey;
                border-bottom-left-radius: 10px;
            }
        }
    
    `}


`